import { useState, useEffect, useCallback } from 'react'
import styles from './index.module.css'
import { Input, Collapse, Empty, Table, Tag } from 'antd'
import { Container, SubContainer, KeyVal, SectionTitle } from '../Layouts'
import { getDeviceDetails } from '../../api/device'
import { LogTable } from '../Project/Logs'
import { AlarmTable } from '../Project/Alarms'
import { dateRender } from '../../utils'
import LocaltionSelect from '../common/LocationSelect'
import HistoryLogs from '../HistoryLogs'
import HistoryAlarms from '../HistoryLogs/alrams'
import { textRender, dateTimeRender } from '../../utils'
import { TaskTypeOptions, TaskStatusOptions, TaskStatus } from '../../constants'
import { useRequest } from '../../hooks'
import { searchTask } from '../../api/task'
export default function Devices() {
    const [sn, setSn] = useState('')
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState<Record<string, any>>()
    const onSearch = async () => {
        if (!sn) return;
        setLoading(true)
        try {
            const res = await getDeviceDetails(sn);
            setData(res)
        } catch (err) {

        }
        setLoading(false)
    }
    return <section>
        <div className={styles.header}>
            <Input.Search name='sn' loading={loading} value={sn} onSearch={onSearch} onChange={(e) => {
                setSn(e.target.value)
            }} size='large' placeholder='请输入设备序列号' allowClear />
        </div>
        <Container>
            <h3>查询结果</h3>
            {
                data ?
                    <div>

                        <div style={{
                            display: 'flex', justifyContent: 'space-between'
                        }}>
                            <SubContainer style={{ display: 'flex', flex: 1, flexDirection: 'column', background: 'transparent' }}>
                                <SectionTitle>设备信息</SectionTitle>
                                <br />
                                <div>
                                    <KeyVal name='设备序列号' value={data.deviceSn} />
                                    <KeyVal name='展位号' value={data.name} />
                                    <KeyVal name='网关名' value={data.gatewayName} />
                                    <KeyVal name='网关MAC地址' value={data.gatewayMac} />
                                </div>
                            </SubContainer>
                            <SubContainer style={{ display: 'flex', flex: 1, flexDirection: 'column', background: 'transparent' }}>
                                <SectionTitle>展会信息</SectionTitle>
                                <br />
                                <div>
                                    <KeyVal name='展会名称' value={data.projectInfo.name} />
                                    <KeyVal name='场馆' value={<LocaltionSelect plain value={data.projectInfo.organizationId + ''} />} />
                                    <KeyVal name='开始时间' value={dateRender(data.projectInfo.startDate)} />
                                    <KeyVal name='结束时间' value={dateRender(data.projectInfo.endDate)} />
                                </div>
                            </SubContainer>
                        </div>
                        <SubContainer style={{ background: 'transparent' }}>
                            <SectionTitle>实时数据</SectionTitle>
                            <br />
                            <LogTable pagination={false} data={data.realtimeInfo} />
                        </SubContainer>

                        <SubContainer style={{ background: 'transparent' }}>
                            <SectionTitle>告警信息</SectionTitle>
                            <br />
                            <AlarmTable pagination={false} data={data.alarmInfo} />
                        </SubContainer>

                        <SubContainer style={{ background: 'transparent' }}>
                            <SectionTitle>工单详情</SectionTitle>
                            <br />
                            <TaskTable deviceSn={sn} />
                        </SubContainer>

                        <Collapse
                            defaultActiveKey={[]}
                            items={[
                                {
                                    key: '1',
                                    label: <strong>历史数据</strong>,
                                    children:
                                        <HistoryLogs showCertain={{
                                            projectId: data?.projectId,
                                            devSn: data?.deviceSn
                                        }} />
                                },
                                {
                                    key: '2',
                                    label: <strong>历史告警</strong>,
                                    children:
                                        <HistoryAlarms showCertain={{
                                            projectId: data?.projectId,
                                            devSn: data?.deviceSn
                                        }} />
                                },

                            ]}
                        >
                        </Collapse>
                    </div>
                    :
                    <Empty />
            }
        </Container>
    </section>
}


function TaskTable({ deviceSn }: { deviceSn: string }) {
    const [data, setData] = useState<TaskRecord[]>([])
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        setLoading(true)
        searchTask({
            deviceSn
        })
            .then(res => {
                setData(res.data)
                setLoading(false)
            }).catch(err => {
                setLoading(false)
            })
    }, [deviceSn]);
    return (
        <Table
            rowKey='taskId'
            scroll={{ x: 1 }}
            columns={[
                {
                    dataIndex: 'taskId',
                    title: 'ID',
                    fixed: true,
                    width: 100,
                },
                {
                    fixed: true,
                    dataIndex: 'projectName',
                    title: '展会名称',
                    width: 140,
                    render: textRender
                },
                {
                    dataIndex: 'description',
                    title: '工单描述',
                    fixed: true,
                    width: 400,
                    render: textRender
                },
                {
                    dataIndex: 'taskType',
                    title: '工单类型',
                    width: 100,
                    render: (taskType: string) => {
                        return TaskTypeOptions.find(i => i.value === taskType)?.label
                    }
                },

                {
                    dataIndex: 'taskStatus',
                    title: '工单状态',
                    width: 100,
                    render: (taskStatus: string) => {
                        const text = TaskStatusOptions.find(i => i.value === taskStatus)?.label;
                        return <Tag color={taskStatus === TaskStatus.ACCEPT ? '#adc6ff' :
                            taskStatus === TaskStatus.INITIAL ?
                                'red' : 'green'}>{text}</Tag>
                    }
                },
                {
                    dataIndex: 'acceptUser',
                    title: '认领人',
                    width: 100,
                    render: (acceptor: RelatedUser) => {
                        return textRender(acceptor?.username)
                    }
                },
                {
                    dataIndex: 'acceptTime',
                    title: '认领时间',
                    width: 200,
                    render: dateTimeRender
                },
                {
                    dataIndex: 'completeUser',
                    title: '完成确认人',
                    width: 150,
                    render: (completeUser: RelatedUser) => textRender(completeUser?.username)
                },
                {
                    dataIndex: 'completeTime',
                    title: '完成确认时间',
                    width: 200,
                    render: dateTimeRender
                },
                {
                    dataIndex: 'createDatetime',
                    title: '创建时间',
                    width: 200,
                    render: textRender
                },
            ]}
            loading={loading}
            dataSource={data}
        />
    )
}